import { useState } from "react";
import { ResourceDetailDrawer } from "@/components/dashboard/ResourceDetailDrawer";
import { ResourceHeatmap } from "@/components/dashboard/ResourceHeatmap";

export function SchedulePage() {
  const [openResourceId, setOpenResourceId] = useState<string | null>(null);

  return (
    <div className="px-6 py-5">
      <div className="mb-5">
        <h1 className="font-display text-[20px] font-bold leading-tight">Schedule</h1>
        <p className="text-[12px] text-muted-foreground">
          Resource load by week — spot capacity risk and rebalance Pods.
        </p>
      </div>

      <ResourceHeatmap onOpenResource={setOpenResourceId} />

      {openResourceId && (
        <ResourceDetailDrawer id={openResourceId} onClose={() => setOpenResourceId(null)} />
      )}
    </div>
  );
}
